import type { ReactNode } from 'react';
import { cn, Heading, Button } from '@simplywallst/ui-core/next';
import ChevronDownSmallSolid from '@simplywallst/ui-core/icons/ChevronDownSmallSolid';

import {
  PortfolioDropdown,
  UnauthenticatedPortfolioDropdown,
} from '../PortfolioDropdown';

import type { Portfolio } from '@/hooks/portfolio/usePortfolio';
import useUser from '@/hooks/useUser';

type Props = {
  portfolio?: Portfolio;
  className?: string;
  children?: ReactNode;
};

export const PortfolioPageHeader = ({
  portfolio,
  children,
  className,
}: Props) => {
  const { data: user } = useUser();
  return (
    <header
      data-cy-id="portfolio-header"
      data-testid="portfolio-header"
      className={cn(
        'grid grid-cols-[auto_min-content] grid-rows-[auto] items-center justify-between px-x2 md:grid-cols-[auto_auto] lg:px-x0',
        className
      )}
    >
      <div className="-translate-x-x1">
        {user.loggedIn ? (
          <PortfolioDropdown portfolioId={portfolio?.id ?? null}>
            <Button
              variant="subtle"
              size="medium"
              className="mr-x1 grid grid-cols-[auto_24px] items-center px-x0_75 lg:h-x5"
            >
              <Heading
                as="h1"
                size="mega"
                className="w-full truncate text-nowrap text-solid"
              >
                {portfolio?.name ?? 'My Portfolio'}
              </Heading>
              <ChevronDownSmallSolid className="fill-soft" />
            </Button>
          </PortfolioDropdown>
        ) : (
          <UnauthenticatedPortfolioDropdown portfolioId={portfolio?.id ?? null}>
            <Button
              variant="subtle"
              size="medium"
              className="mr-x1 grid grid-cols-[auto_24px] items-center px-x0_75 lg:h-x5"
            >
              <Heading
                as="h1"
                size="mega"
                className="w-full truncate text-nowrap text-solid"
              >
                {portfolio?.name ?? 'My Portfolio'}
              </Heading>
            </Button>
          </UnauthenticatedPortfolioDropdown>
        )}
      </div>
      {children}
    </header>
  );
};
